module.exports = __webpack_public_path__ + "img/c9f334c4e5861a70340be1840695515b.png";